module.exports = __webpack_public_path__ + "static/Regiondo-716b2105bc98ec6ebe8e5420abe9e41a.svg";